import { render, staticRenderFns } from "./HiColorSwatch.vue?vue&type=template&id=5a6ede5f&scoped=true&"
import script from "./HiColorSwatch.vue?vue&type=script&lang=js&"
export * from "./HiColorSwatch.vue?vue&type=script&lang=js&"
import style0 from "./HiColorSwatch.vue?vue&type=style&index=0&id=5a6ede5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ede5f",
  null
  
)

export default component.exports